export var RoleCategory;
(function (RoleCategory) {
    RoleCategory[RoleCategory["Overig"] = 0] = "Overig";
    RoleCategory[RoleCategory["Projectleider"] = 1] = "Projectleider";
    RoleCategory[RoleCategory["Uitvoerende"] = 2] = "Uitvoerende";
})(RoleCategory || (RoleCategory = {}));
export const RoleCategoryMap = new Map([
    [RoleCategory.Overig, 'Overig'],
    [RoleCategory.Projectleider, 'Projectleider'],
    [RoleCategory.Uitvoerende, 'Uitvoerende']
]);
